import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { LanguageSelect } from '@/shell/LanguageSelect'
import { Wordmark } from './SessionProvider'

/** The full-page frame for /login, /no-account and /setup-incomplete. */
export function AuthLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  return (
    <div className="soc-backdrop relative h-full overflow-auto">
      <div className="mx-auto grid min-h-full max-w-[1120px] grid-cols-1 items-center gap-12 px-6 py-12 lg:grid-cols-[1.1fr_1fr] lg:px-10">
        <div className="hidden lg:block">
          <Wordmark size="lg" />
          <div className="soc-plate-rule mt-4 w-48" />
          <p className="soc-label mt-6 text-brass">{t('auth.handlerMode')}</p>
          <p className="soc-flavour mt-6 max-w-[34ch] text-[22px] leading-snug">{t('auth.flavour')}</p>
          <p className="mt-6 max-w-[46ch] text-ink-mute">{t('auth.pitch')}</p>
        </div>
        <div className="w-full max-w-[440px] justify-self-center lg:justify-self-end">
          <div className="mb-8 lg:hidden">
            <Wordmark />
            <p className="soc-label mt-2 text-brass">{t('auth.handlerMode')}</p>
          </div>
          {children}
          <div className="mt-6 flex justify-end">
            <LanguageSelect />
          </div>
        </div>
      </div>
    </div>
  )
}
